var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mb-2",attrs:{"color":"info","small":""}},[_c('v-icon',{staticClass:"ml-1"},[_vm._v("\n\t\tmdi-camera\n\t")]),_c('span',[_vm._v("בחירת תמונה")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }